import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { eventSwitchSx } from "../../../../common/dashboard/switchStyles";

type EventRegistrationRequirementsControlProps = {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
};

// First block of the Registration Settings card (Claude Design (8) Create
// Event Screen.dc.html:413-424): 14px/600 heading, 13px helper, toggle.
const EventRegistrationRequirementsControl = ({
  enabled,
  onChange,
}: EventRegistrationRequirementsControlProps): React.ReactElement => (
  <section
    aria-labelledby="event-registration-requirements-heading"
    className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between"
  >
    <div className="min-w-0 flex-1">
      <h3
        id="event-registration-requirements-heading"
        className="text-[14px] font-semibold leading-[normal] text-[#0A0A0A]"
      >
        Event Registration Requirements
      </h3>
      <p
        id="event-registration-requirements-description"
        className="mt-[4px] text-[13px] leading-[normal] text-[#0A0A0A]"
      >
        Disable this option if you do not require attendees to register for this event on your website.
      </p>
    </div>
    <FormControlLabel
      className="shrink-0"
      control={
        <Switch
          checked={enabled}
          onChange={({ target }) => onChange(target.checked)}
          inputProps={{
            "aria-describedby": "event-registration-requirements-description",
            "aria-labelledby": "event-registration-requirements-heading",
          }}
          sx={{ ...eventSwitchSx, mr: 1 }}
        />
      }
      label={enabled ? "ENABLED" : "DISABLED"}
      sx={{
        m: 0,
        "& .MuiFormControlLabel-label": {
          color: enabled ? "#10B981" : "#727272",
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: "0.04em",
        },
      }}
    />
  </section>
);

export default EventRegistrationRequirementsControl;
